import type { AITranslationOptions } from '../types';

export const AITranslationOptionsService = Symbol.for('AITranslationOptionsService');

export interface AITranslationOptionsService {
    initialize: (patentLang: string) => AITranslationOptions;
}
